import { Component } from '@opten/compiler/metadata/component';
import debounce from '@opten/reactive/debounce';

@Component({ className: 'js-video-background' })
export class VideoBackgroundComponent {
	private element: HTMLElement;
	private ratio = 21 / 9;

	constructor(private parent: HTMLElement) {
		this.element = parent.querySelector('.js-video-background-item') as HTMLElement;

		this.ratio = this.calculateRatio();

		this.calculate();

		window.addEventListener(
			'resize',
			debounce(() => this.calculate(), 100)
		);

		window.addEventListener(
			'orientationchange',
			debounce(() => this.calculate(), 100)
		);

		document.addEventListener(
			'lazyloaded',
			debounce(() => this.calculate(), 100)
		);
	}

	calculate() {
		const parentRatio = this.parent.clientWidth / this.parent.clientHeight;

		let top = 0;
		let bottom = 0;
		let left = 0;
		let right = 0;

		if (parentRatio > this.ratio) {
			const height = this.parent.clientWidth / this.ratio;
			top = bottom = -1 * ((height - this.parent.clientHeight) / 2) - 10;
		} else if (parentRatio < this.ratio) {
			const width = this.parent.clientHeight * this.ratio;
			left = right = -1 * ((width - this.parent.clientWidth) / 2) - 10;
		}

		this.element.style.top = top + 'px';
		this.element.style.bottom = bottom + 'px';
		this.element.style.left = left + 'px';
		this.element.style.right = right + 'px';
	}

	calculateRatio(): number {
		const dataRatio = this.parent.getAttribute('data-ratio');

		switch (dataRatio) {
			case '21:9':
				return 21 / 9;
			case '16:9':
				return 16 / 9;
			case '4:3':
				return 4 / 3;
			default:
				return 16 / 9;
		}
	}
}
